import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { Grid } from 'semantic-ui-react';
import ContentImage from './ContentImage';
import ContentMarkup from './ContentMarkup';
import { TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';
export default function Content(_ref) {
  var children = _ref.children,
    gridProps = _objectWithoutProperties(_ref, _excluded);
  if (React.Children.count(children) === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Grid, _extends({
    className: "content-section"
  }, gridProps), children);
}
Content.defaultProps = {
  children: null,
  columns: 'equal',
  textAlign: 'center',
  verticalAlign: 'middle'
};
Content.Markup = ContentMarkup;
Content.Image = ContentImage;